import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import GolfClubStoragePage from '@/v2/components/pages/public-pages/golf-club-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/golf-club-storage-page'

interface GolfClubStoragePageProps {}

const Page: React.FC<GolfClubStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.golf_club_storage.title ?? ''}
        keywords={META_CONTENTS.golf_club_storage?.keywords ?? ''}
        description={META_CONTENTS.golf_club_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <GolfClubStoragePage />
    </>
  )
}

export default Page
